import { Model } from '@nozbe/watermelondb';

import { DatabaseValidation } from '../../../../types/validation';
import { DBValidationError } from '../../../validation/databaseInput';
import { getValidationRecord } from '../../../validation/schemas/common';
import { ValidationOperation } from '../../../validation/validator';

type ValidatablePreparedItem = {
    table: keyof DatabaseValidation;
    record: Model;
    operation: ValidationOperation;
};

export function validateEntityRecords(
    records: ReadonlyArray<ValidatablePreparedItem>,
    validation: DatabaseValidation,
): void {
    for (const { table, record, operation } of records) {
        const raw = getValidationRecord(
            record._raw as Record<string, unknown>,
            table,
            operation,
        );
        const validator = validation[table][operation];
        // TS loses table↔record correlation on unions; runtime keys always match.
        try {
            (validator.execute as (input: unknown) => unknown)(raw);
        } catch (error) {
            const message =
                error instanceof Error ? error.message : String(error);
            throw new DBValidationError(
                `[table=${table} operation=${operation} recordId=${record.id}] ${message}`,
            );
        }
    }
}
